export default __webpack_public_path__ + "static/media/deal-13.acf8dee8.webp";